import React from "react";
import "./MainMenu.css";
import playImg from "../../Assets/play.png";

function MainMenu() {
  document.querySelector("body").style.overflow = "hidden";

  return (
    <div className="MainMenu">
      <div></div>
      <div className="Title">Teka-Teki Al-Qur'an</div>
      <a href="/level" className="playBtn">
        <div className="img-wraps-mainmenu">
          <img src={playImg} width="40px" alt="didn't load properly"></img>
        </div>

        <div className="main-wraps-mainmenu">
          <p className="main-text">Main</p>
        </div>
      </a>
      <div className="circle"></div>
      <div className="diamond"></div>
    </div>
  );
}

export default MainMenu;
